export class ClaimTypes {
    static NameIdentifier = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier';
    static Name = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name';
    static Role = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';
    static Email = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress';
    static Country = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/country';
}
